import { VOLATILITY_LEVELS, MOD_LABELS, type VolatilityLevel } from '../../../../modules/api';

export interface VolatilityTabsProps {
  value: VolatilityLevel;
  onChange: (level: VolatilityLevel) => void;
}

export function VolatilityTabs({ value, onChange }: VolatilityTabsProps) {
  return (
    <div role="tablist" aria-label="Volatility level" className="flex items-center gap-2">
      {VOLATILITY_LEVELS.map((level) => {
        const selected = level === value;
        return (
          <button
            key={level}
            type="button"
            role="tab"
            aria-selected={selected}
            onClick={() => onChange(level)}
            className="rounded-full px-4 py-1.5 text-[13px] font-semibold leading-[20px] transition-colors"
            style={{
              color: selected
                ? 'var(--co-OddsBreakdown-modValueColor, #ffffff)'
                : 'var(--co-OddsBreakdown-modLabelColor, rgba(255,255,255,0.5))',
              border: `1px solid ${
                selected
                  ? 'var(--co-OddsBreakdown-modValueColor, #ffffff)'
                  : 'var(--co-OddsBreakdown-borderColor, rgba(171,174,179,0.24))'
              }`,
              backgroundColor: selected
                ? 'var(--co-OddsBreakdown-barTrack, rgba(255,255,255,0.05))'
                : 'transparent',
            }}
          >
            {MOD_LABELS[level]}
          </button>
        );
      })}
    </div>
  );
}
